import Vue from 'vue'
import { Fragment } from 'vue-frag'

Vue.component('Fragment', Fragment)
